import { render, staticRenderFns } from "./my-info.vue?vue&type=template&id=b43e7bc0&scoped=true"
import script from "./my-info.vue?vue&type=script&lang=js"
export * from "./my-info.vue?vue&type=script&lang=js"
import style0 from "./my-info.vue?vue&type=style&index=0&id=b43e7bc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b43e7bc0",
  null
  
)

export default component.exports